import React from 'react';
import { useParams } from 'react-router-dom';
import { MODULE_TYPES } from '../../../common/constants';
import FormLayout from '../../component/layout/FormLayout';
import { FORM_TYPES, useEditPage } from '../../pages/context/EditPageProvider';
import { usePagePreview } from '../../pages/context/PreviewPageProvider';
import { Modules as BaseModules } from '../../pages/component/pageModules/RightPanel';
import { PlaceHolderComponents } from '../../pages/component/pageModules/LeftPanel';
import TemplateSettings from './TemplateSettings';

const Modules = {
  ...BaseModules,
  [MODULE_TYPES.SETTINGS]: TemplateSettings
};

const TemplateRightPanel = () => {
  const {
    selectionType,
    form,
    clearRightPanel,
    updateModule,
    deleteModule,
    isDefaultPage,
    pageType
  } = useEditPage();
  const { refetch } = usePagePreview();
  const { id } = useParams();

  const handleCancel = () => {
    if (form.type === FORM_TYPES.ADD) {
      deleteModule(form.index);
    }
    clearRightPanel();
  };

  const handleSuccess = (data) => {
    updateModule(data);
    clearRightPanel();
    refetch();
  };

  if (!selectionType) return <FormLayout />;

  const FormComponent = Modules[selectionType];
  if (!FormComponent) return <FormLayout />;

  if (selectionType === MODULE_TYPES.ADD)
    return (
      <FormLayout>
        <FormComponent />
      </FormLayout>
    );

  return (
    <FormLayout title={PlaceHolderComponents?.[selectionType]?.title}>
      <FormComponent
        key={selectionType}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
        pageId={id}
        form={form}
        type={selectionType}
        isDefaultPage={isDefaultPage}
        pageType={pageType}
      />
    </FormLayout>
  );
};

export default TemplateRightPanel;
